import AcademyAlliance from './AcademyAlliance';

export { AcademyAlliance };
export default AcademyAlliance;
